import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';
import type { FilterState } from '../state/filter.state';
import { initialFilterState } from '../state/filter.state';
import { LoadFilterNodesAction, LoadFilterNodesFailureAction, LoadFilterNodesSuccessAction } from '../action/filter.action';

const filterReducer = createReducer(
  initialFilterState,
  on(LoadFilterNodesAction, (state: FilterState) => ({ ...state })),
  on(LoadFilterNodesSuccessAction, (state: FilterState) => ({ ...state })),
  on(LoadFilterNodesFailureAction, (state: FilterState) => ({ ...state })),
);

export function FilterReducer(state: FilterState | undefined, action: Action): FilterState {
  return filterReducer(state, action);
}
